module.exports = __webpack_public_path__ + "static/media/commercial.0722152f.svg";